<template>
    <section>
        <div class="row">
            <div class="col-lg-10 col-12 pt-5">
                <div class="row">
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Nama Siswa</h4>
                        <p class="font-weight-bold mb-0">{{ student.user.name }}</p>
                    </div>
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Cabang</h4>
                        <p class="font-weight-bold mb-0">{{ student.branch.name }}</p>
                    </div>
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Kelas</h4>
                        <p class="font-weight-bold mb-0">{{ student.btaGrade.name }}</p>
                    </div>
                    <!--<div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Tipe Program</h4>
                        <p class="font-weight-bold mb-0">{{ student.studentVerified.pattern.branchProgram.programType.name }}</p>
                    </div>-->
                    <div class="col-auto mb-3">
                        <div class="row">
                            <div class="col-auto">
                                <h4 class="mb-1 text-muted font-weight-medium">Pola Semester 1</h4>
                                <p class="font-weight-bold mb-0" v-for="period in student.studentVerified.pattern.periods" v-bind:key="period.id">
                                    {{ $moment.weekdays(period.day) }}
                                </p>
                            </div>
                            <div class="col-auto">
                                <h4 class="mb-1 text-muted font-weight-medium">Sesi Semester 1</h4>
                                <p class="font-weight-bold mb-0" v-for="period in student.studentVerified.pattern.periods" v-bind:key="period.id">
                                    {{ [period.start, "HH:mm:ss"] | moment("HH.mm") }} - {{ [period.end, "HH:mm:ss"] | moment("HH.mm") }} ({{ period.slots }})
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Kelas Semester 1</h4>
                        <p class="font-weight-bold mb-0">{{ student.studentVerified.branchClass.name }}</p>
                    </div>
                    <div class="col-auto mb-3" v-if="student.studentVerified.secondPattern">
                        <div class="row">
                            <div class="col-auto">
                                <h4 class="mb-1 text-muted font-weight-medium">Pola Semester 2</h4>
                                <p class="font-weight-bold mb-0" v-for="period in student.studentVerified.secondPattern.periods" v-bind:key="period.id">
                                    {{ $moment.weekdays(period.day) }}
                                </p>
                            </div>
                            <div class="col-auto">
                                <h4 class="mb-1 text-muted font-weight-medium">Sesi Semester 2</h4>
                                <p class="font-weight-bold mb-0" v-for="period in student.studentVerified.secondPattern.periods" v-bind:key="period.id">
                                    {{ [period.start, "HH:mm:ss"] | moment("HH.mm") }} - {{ [period.end, "HH:mm:ss"] | moment("HH.mm") }} ({{ period.slots }})
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto mb-3" v-if="student.studentVerified.secondBranchClass">
                        <h4 class="mb-1 text-muted font-weight-medium">Kelas Semester 2</h4>
                        <p class="font-weight-bold mb-0">{{ student.studentVerified.secondBranchClass.name }}</p>
                    </div>
                    <div class="col-auto mb-3" v-if="student.studentVerified.thirdBranchClass">
                        <h4 class="mb-1 text-muted font-weight-medium">Kelas Intensif UTBK</h4>
                        <p class="font-weight-bold mb-0">{{ student.studentVerified.thirdBranchClass.name }}</p>
                    </div>
                    <div class="col-auto mb-3" v-if="student.studentVerified.fourthBranchClass">
                        <h4 class="mb-1 text-muted font-weight-medium">Kelas Intensif Mandiri</h4>
                        <p class="font-weight-bold mb-0">{{ student.studentVerified.fourthBranchClass.name }}</p>
                    </div>
                </div>
                <div class="row justify-content-end align-items-center">
                    <div class="col-sm-auto col my-2">
                        <form v-on:submit.prevent="fetchAttendance()" class="form-inline">
                            <select v-model="form.semester" class="form-control form-control-sm m-1">
                                <option value="">Pilih Semester...</option>
                                <option v-for="semester in semesters" v-bind:value="semester.id" v-bind:key="semester.id">{{ semester.name }}</option>
                            </select>
                            <select v-model="form.month" class="form-control form-control-sm m-1">
                                <option value="">Pilih Bulan...</option>
                                <option v-for="month in months" v-bind:value="month.value" v-bind:key="month.value">{{ month.text }}</option>
                            </select>
                            <select v-model="form.year" class="form-control form-control-sm m-1">
                                <option value="">Pilih Tahun...</option>
                                <option v-for="year in years" v-bind:value="year">{{ year }}</option>
                            </select>
                            <button type="submit" class="btn btn-danger btn-sm px-3 m-1 ml-auto ml-sm-1">
                                Filter
                            </button>
                        </form>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mb-4">
                        <div id="table-primary" class="table-responsive" v-dragscroll="!isMobile()">
                            <table class="table" style="width: 1200px;">
                                <thead>
                                    <tr class="text-danger font-weight-bold">
                                        <th scope="col">
                                            Hari/Tanggal
                                        </th>
                                        <th scope="col" v-for="slot in sessionCount" style="width: 150px;">
                                            Sesi {{ slot }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="attendance in attendances">
                                        <td class="shadow-sm rounded bg-white text-center font-weight-medium py-4">
                                            <p class="mb-0">{{ [attendance.date, "YYYY-MM-DD"] | moment("dddd, D MMMM YYYY") }}</p>
                                        </td>
                                        <template v-for="slot in sessionCount">
                                            <td class="rounded py-4" v-if="session(attendance, slot)" v-bind:class="session(attendance, slot).studentAttendance ? classStyle(session(attendance, slot).studentAttendance.attendanceStatus) : ''">
                                                <p class="mb-0" v-if="session(attendance, slot).studentAttendance">{{ session(attendance, slot).studentAttendance.attendanceStatus.name }}</p>
                                                <i class="fa fa-minus" v-else></i>
                                            </td>
                                            <td class="rounded py-4 bg-transparent" v-else></td>
                                        </template>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { dragscroll } from 'vue-dragscroll';
    import { semesters } from '@/params.js';

    export default {
        name: "AccountStudentAttend",
        directives: {dragscroll},
        watch: {
            'form.start'(start) {
                if (start) {
                    if (!this.form.end || this.$moment(start).isAfter(this.$moment(this.form.end))) {
                        this.form.end = start;
                    }
                }
            }
        },
        data() {
            return {
                form: {
                    semester: 1,
                    year: '',
                    month: ''
                },
                student: {user: {}, branch: {}, btaGrade: {}, studentVerified: {pattern: {branchProgram: {programType: {}}}, branchClass: {}}},
                attendances: [],
                sessionCount: 6,
                statuses: [],
                months: [],
                years: [],
                semesters: semesters,
                classStyles: {
                    1: 'bg-success shadow-sm',
                    2: 'bg-purple text-white shadow-sm',
                    3: 'bg-warning shadow-sm',
                    4: 'background-primary text-white shadow-sm',
                    5: 'bg-info text-white shadow-sm',
                    6: 'bg-orange text-white shadow-sm'
                }
            };
        },
        methods: {
            fetchAttendance() {
                this.axios.get(process.env.API_URL + '/attendance/student-attendance', {params: this.form}).then(response => {
                    this.attendances = response.data.data;
                });
            },
            session(attendance, slot) {
                return attendance.sessions.find(session => session.slot === slot);
            },
            classStyle(status) {
                return this.classStyles[status.id] ? this.classStyles[status.id] : '';
            },
            isMobile() {
                return 'ontouchstart' in window || navigator.msMaxTouchPoints;
            }
        },
        created() {
            this.form.month = this.$moment().format('MM');
            this.form.year = this.$moment().format('YYYY');
            
            const months = this.$moment().localeData('id').months();
            for (let i = 0; i < months.length; i++) {
                this.months.push({text: months[i], value: (i + 1).toString().padStart(2, '0')});
            }
            const currentYear = parseInt(this.$moment().format('YYYY'));
            for (let year = currentYear; year >= 2018; year--) {
                this.years.push(year.toString());
            }
            
            this.axios.all([
                this.axios.get(process.env.API_URL + '/student/profile'),
                this.axios.get(process.env.API_URL + '/attendance-status')
            ]).then(this.axios.spread(function (responseStudent, responseStatus) {
                this.student = responseStudent.data.data;
                this.statuses = responseStatus.data.data;

                this.fetchAttendance();
            }.bind(this)));

            document.title = 'Laporan Kehadiran - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    table.table {border-spacing: 0.5rem 1rem; }
</style>


// WEBPACK FOOTER //
// src/components/account/student/Attend.vue